export default __webpack_public_path__ + "static/media/flag_vi.079d66e4.svg";